module.exports = __webpack_public_path__ + "static/media/to-the-point.90a6d5af.mp3";